module.exports = __webpack_public_path__ + "img/b79b2ed.jpg";